export const rubrosHistoricos = [
   {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2025_1T.zip"
            },
           {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2025_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2025_3T.zip"
            },
            /* {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2025_4T.zip"
            }*/
        ]
    }, 
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2024_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2024_2T.zip"
            },
          {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2024_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2024_4T.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2023_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2023_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2023_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2023_4T.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2022_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2022_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2022_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2022_4T.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2021_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2021_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2021_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2021_4T.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2020_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2020_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2020_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2020_4T.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2019_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2019_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2019_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2019_4T.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2018_1T.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2018_2T.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2018_3T.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2018_4T.zip"
            }
        ]
    },
   /* {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/2018_1T.zip"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "whttps://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/Historico/Historico_21_Rubros.zip"
            }
        ]
    }*/
]